var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Box, Grid } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import Webcam from 'react-webcam';
import Tesseract from 'tesseract.js';
import { InputBox, MuiButton, MuiPopup } from '../../../components';
import { showNotification } from '../../../redux/commonSlice';
var ScannerComponent = function (props) {
    var scannerRegex = props.scannerRegex, callback = props.callback, setShowScanner = props.setShowScanner, openPopup = props.openPopup;
    var dispatch = useDispatch();
    var webcamRef = useRef(null);
    var _a = useState(''), numberPlate = _a[0], setNumberPlate = _a[1];
    var _b = useState(true), scanning = _b[0], setScanning = _b[1];
    var _c = useState(false), processing = _c[0], setProcessing = _c[1];
    var _d = useState(false), searchPopup = _d[0], setSearchPopup = _d[1];
    var _e = useState(false), isFrontCamera = _e[0], setIsFrontCamera = _e[1];
    useEffect(function () {
        if (scanning) {
            var intervalId_1 = setInterval(function () {
                if (!processing) {
                    capture();
                }
            }, 1000);
            return function () { return clearInterval(intervalId_1); };
        }
    }, [scanning]);
    var triggerFlash = function () {
        var flashElement = document.getElementById('flash-effect');
        if (flashElement) {
            flashElement.classList.add('active');
            setTimeout(function () { return flashElement.classList.remove('active'); }, 200);
        }
    };
    var capture = function () { return __awaiter(void 0, void 0, void 0, function () {
        var imageSrc;
        return __generator(this, function (_a) {
            triggerFlash();
            if (webcamRef.current) {
                imageSrc = webcamRef.current.getScreenshot();
                if (imageSrc) {
                    console.log('Captured image: ', imageSrc);
                    setProcessing(true);
                    performOCR(imageSrc);
                }
            }
            return [2 /*return*/];
        });
    }); };
    var performOCR = function (image) {
        Tesseract.recognize(image, 'eng', {
            logger: function (m) { return console.log(m); }
        }).then(function (_ref) {
            var text = _ref.data.text;
            console.log('OCR result: ', text);
            var filteredText = filterNumberPlateText(text);
            setProcessing(false);
            if (filteredText) {
                setNumberPlate(filteredText);
                setScanning(false);
                dispatch(showNotification({
                    isOpen: true,
                    message: 'Number plate detected successfully',
                    method: 'success'
                }));
            }
            else {
                dispatch(showNotification({
                    isOpen: true,
                    message: 'Unable to detect a valid number plate',
                    method: 'error'
                }));
            }
        }).catch(function (error) {
            console.error('OCR error: ', error);
            setProcessing(false);
        });
    };
    var filterNumberPlateText = function (text) {
        var sanitizedText = text.replace(/[^A-Z0-9\n\s]/gi, '').toUpperCase();
        var singleLineRegex = /^[A-Z]{2}\d{2}[A-Z]{1,2}\d{1,4}$/;
        var twoLinePart1Regex = /^[A-Z]{2}\d{2}$/;
        var twoLinePart2Regex = /^[A-Z]{1,2}\d{1,4}$/;
        var lines = sanitizedText.split('\n').map(function (line) { return line.replace(/\s+/g, '').trim(); }).filter(function (line) { return line.length > 0; });
        console.log('Sanitized Lines:', lines);
        var aggregatedText = lines.join('');
        console.log('Aggregated Text:', aggregatedText);
        if (singleLineRegex.test(aggregatedText)) {
            return aggregatedText;
        }
        if (lines.length >= 2) {
            for (var i = 0; i < lines.length - 1; i++) {
                var part1 = lines[i].trim();
                var part2 = lines[i + 1].trim();
                if (twoLinePart1Regex.test(part1) && twoLinePart2Regex.test(part2)) {
                    var combinedResult = "".concat(part1).concat(part2);
                    if (singleLineRegex.test(combinedResult)) {
                        return combinedResult;
                    }
                }
            }
        }
        for (var _i = 0, lines_1 = lines; _i < lines_1.length; _i++) {
            var line = lines_1[_i];
            if (singleLineRegex.test(line)) {
                return line;
            }
        }
        return '';
    };
    var handleScanAnother = function () {
        setNumberPlate('');
        setScanning(true);
    };
    var onSearch = function () {
        setSearchPopup(true);
        callback(numberPlate);
    };
    var toggleCamera = function () {
        setIsFrontCamera(function (prev) { return !prev; });
    };
    var videoConstraints = {
        facingMode: isFrontCamera ? 'user' : {
            exact: 'environment'
        }
    };
    return /*#__PURE__*/ React.createElement(MuiPopup, {
        openPopup: openPopup,
        onClose: function () { return setShowScanner(false); },
        showDialogTitle: false
    }, /*#__PURE__*/ React.createElement("div", {
        id: "flash-effect",
        className: "flash"
    }), /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        style: {
            height: '100%',
            width: '100%'
        }
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        style: {
            height: '100%',
            position: 'relative'
        }
    }, scanning && /*#__PURE__*/ React.createElement(Webcam, {
        audio: false,
        ref: webcamRef,
        screenshotFormat: "image/jpeg",
        videoConstraints: videoConstraints,
        style: {
            height: '100%',
            width: '100%'
        }
    }), scanning && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Box, {
        border: 3,
        borderColor: "white",
        position: "absolute",
        top: "50%",
        left: "50%",
        style: {
            transform: 'translate(-50%, -50%)',
            width: '80%',
            height: 'auto',
            aspectRatio: '2/1'
        }
    }), /*#__PURE__*/ React.createElement(MuiButton, {
        name: "Flip Camera",
        variant: "contained",
        color: "primary",
        onClick: toggleCamera,
        fullWidth: true
    }), /*#__PURE__*/ React.createElement(MuiButton, {
        name: "Flash",
        variant: "contained",
        color: "primary",
        onClick: triggerFlash,
        fullWidth: true,
        style: {
            marginTop: 8
        }
    })), !scanning && /*#__PURE__*/ React.createElement(MuiPopup, {
        openPopup: !scanning,
        showDialogTitle: false,
        backdropEnable: false,
        onClose: searchPopup
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(InputBox, {
        label: "Detected Number Plate",
        value: numberPlate,
        variant: "outlined",
        fullWidth: true,
        margin: "normal",
        InputProps: {
            readOnly: true
        }
    }))), /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        mt: 2,
        spacing: 1,
        display: 'flex',
        justifyContent: 'space-between'
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 4
    }), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 4
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        name: "Retry",
        variant: "outlined",
        color: "secondary",
        onClick: handleScanAnother,
        fullWidth: true
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 4
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        name: "Search",
        variant: "contained",
        color: "primary",
        onClick: onSearch,
        fullWidth: true
    })))))));
};
export default ScannerComponent;
